export const FormFieldMixin = (Base) =>
  class extends Base {
    pushTextVariables(properties) {
      this.element
        .querySelectorAll('*[data-action*="pushTextVariable"]')
        .forEach((textVariableInput) => {
          const targetParam = textVariableInput.dataset.printessTargetParam;

          const hasMatch = properties.some(prop => prop.ffName === targetParam);

          // Only update a form field if it is part of the current 'displayed' form fields (properties).
          //
          // Calling setFormFieldValue for a field that is not currently displayed does update the internal
          // 'value' of that property, but this has no effect on the actual form field rendering.
          //
          // When the field later becomes visible, the same value would be sent again, but since the value
          // is already set, no visible change occurs and no update is triggered. The onSelectionChangeCallback
          // will always provide the valid, currently displayed properties.
          if (hasMatch) {
            this.setFormFieldValue(targetParam, textVariableInput.value);
          }
        });
    }

    pushTextVariable(event) {
      this.setFormFieldValue(event.params.target, event.target.value);
    }

    setFormFieldValue(field, value) {
      this.editor.api
        .setFormFieldValue(field, value)
        .then(() => {
          // We need to call clearSelection after updating form fields of type select
          this.editor.api.clearSelection();
        })
    }
  };
